export default __webpack_public_path__ + "static/media/c.9a0dc12e.png";